export default __webpack_public_path__ + "media/components/Authorization/Login/profile-bdc25007b1434c7a1739114dc35d67c3.svg";